"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
require("./no-data-found.less");
const NoDataFound = (props) => (React.createElement("div", null,
    props.headerComponent,
    "No Data Found Component"));
exports.default = NoDataFound;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/components/no-data-found/no-data-found.tsx
// module id = 3714
// module chunks = 0